import { Reducer } from 'redux';
import { CollaboratorsGroupsState, GroupsTypes } from './types';

const INITIAL_STATE: CollaboratorsGroupsState = {
  groupsList: [],
  groupData: {
    id: '',
    name: '',
    companyId: '',
    users: [],
  },
  totalCount: 0,
  loading: false,
  error: false,
};

const reducer: Reducer<CollaboratorsGroupsState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // LIST GROUPS
    case GroupsTypes.LIST_GROUPS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        groupsList: INITIAL_STATE.groupsList,
      };
    case GroupsTypes.LIST_GROUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        groupsList: action.payload.groupsList,
        totalCount: action.payload.totalCount,
      };
    case GroupsTypes.LIST_GROUPS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        groupsList: INITIAL_STATE.groupsList,
      };
    // GET GROUP
    case GroupsTypes.GET_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        groupData: INITIAL_STATE.groupData,
      };
    case GroupsTypes.GET_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        groupData: action.payload.groupData,
      };
    case GroupsTypes.GET_GROUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        groupData: INITIAL_STATE.groupData,
      };
    // FILTER GROUPS
    case GroupsTypes.FILTER_GROUPS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        groupsList: INITIAL_STATE.groupsList,
      };
    case GroupsTypes.FILTER_GROUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        groupsList: action.payload.groupsList,
        totalCount: action.payload.totalCount,
      };
    case GroupsTypes.FILTER_GROUPS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        groupsList: INITIAL_STATE.groupsList,
      };
    // CREATE GROUP
    case GroupsTypes.CREATE_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        groupData: INITIAL_STATE.groupData,
      };
    case GroupsTypes.CREATE_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        groupData: action.payload.groupData,
      };
    case GroupsTypes.CREATE_GROUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        groupData: INITIAL_STATE.groupData,
      };
    // UPDATE GROUP
    case GroupsTypes.UPDATE_GROUP_REQUEST:
      return { ...state, loading: true, error: false };
    case GroupsTypes.UPDATE_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        groupData: action.payload.groupData,
      };
    case GroupsTypes.UPDATE_GROUP_FAILURE:
      return { ...state, loading: false, error: true };
    // DELETE GROUP
    case GroupsTypes.DELETE_GROUP_REQUEST:
      return { ...state, loading: true, error: false };
    case GroupsTypes.DELETE_GROUP_SUCCESS:
      return { ...state, loading: false, error: false };
    case GroupsTypes.DELETE_GROUP_FAILURE:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
};

export default reducer;
